export default __webpack_public_path__ + "static/710-b8ebd477999a6244a3880bbc076856c8.gif";